import * as React from 'react';

import * as styles from './SpecialPromoLink.css';
import { Link } from '../Link';

interface ISpecialPromoLinkProps {
  logo?: string;
  onClick?(): void;
  text: string;
  url: string;
}

export const SpecialPromoLink: React.FC<React.PropsWithChildren<ISpecialPromoLinkProps>> = ({
  logo,
  onClick,
  text,
  url,
}) => {
  return (
    <Link className={styles['special-promo']} url={url} onClick={onClick} rel="nofollow noopener">
      {logo && <img className={styles['logo']} src={logo} alt="" />}
      {text}
    </Link>
  );
};
